













import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import AboutMycolorMobile from './AboutMyColorBase.vue'
import AboutMycolorPc from './AboutMyColorPc.vue'

@Component({
  components: {
    AboutMycolorMobile,
    AboutMycolorPc,
  },
})
export default class AboutMyColor extends Vue {
  @Prop({ default: 'div' })
  tag: string
}
